import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import clsx from 'clsx';
import { useKanbanBoardStyles } from 'components/UI/V2/KanbanBoard/KanbanBoard.styles';
import React from 'react';

export interface KanbanCardPosition {
    columnId: string;
    rowId?: string;
}

export interface KanbanCardMoveEvent {
    cardId: string;
    from?: KanbanCardPosition;
    to: KanbanCardPosition;
}

interface KanbanBoardProps {
    id?: string;
    className?: string;
    children?: React.ReactNode;
    onCardMove?: (result: KanbanCardMoveEvent) => void;
}

export const KanbanBoard: React.FC<KanbanBoardProps> = ({ id, className, children, onCardMove }) => {
    const classes = useKanbanBoardStyles();

    React.useEffect(() => {
        return monitorForElements({
            onDrop(args) {
                if (args.source.data.type !== 'kanban-card') {
                    return;
                }

                const cardId = String(args.source.data.cardId ?? '');
                if (!cardId) {
                    return;
                }

                const targets = args.location.current.dropTargets;
                const dropTarget = targets.find(target => target.data.rowId != null) ?? targets[0];
                if (!dropTarget) {
                    return;
                }

                onCardMove?.({
                    cardId,
                    from: {
                        columnId: String(args.source.data.columnId ?? ''),
                        rowId: args.source.data.rowId as KanbanCardPosition['rowId']
                    },
                    to: {
                        columnId: String(dropTarget.data.columnId ?? ''),
                        rowId: dropTarget.data.rowId as KanbanCardPosition['rowId']
                    }
                });
            }
        });
    }, [onCardMove]);

    return (
        <div
            id={id}
            className={clsx(classes.root, className)}
        >
            {children}
        </div>
    );
};
